import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createBrowserHistory } from 'history';

import thunkMiddleware from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';

import { reducers, initialState } from '../reducers';

const history = createBrowserHistory();

const rootReducer = combineReducers({
  ...reducers,
  router: connectRouter(history),
  form: formReducer,
});

const persistConfig = {
  key: 'hpi190601',
  storage,
  whitelist: [],
};

const reducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(routerMiddleware(history), thunkMiddleware))
);

const persistor = persistStore(store);

export { history, store, persistor };
